import { Group } from 'react-konva';
import React, { useEffect, useCallback, useState } from 'react';
import { viewportActions } from '@starflow/app/store';
import { getConfigs, getElements } from '@starflow/app/extension';
import { ElementWrapper } from '../Wrapper';
import { ImageElement } from '../image';

export { GroupOverlayer, GroupOverlayerInner } from './Overlayer';

export const coreElements = {
  image: ImageElement,
};

const staticSeletionMap = {};

const handleDblClick = (event) => {
  const elementId = event.target.name();
  viewportActions.locateElement(elementId, { animate: true });
};

const GroupElements = (props) => {
  const {
    viewport,
    elements,
    groupId,
    groupScale,
    currentElementTool,
    currentCanvasTool,
    editingElementId,
    draggable,
    onDragEnd,
  } = props;

  const extensionElements = getElements();

  const handleDblClick = useCallback(() => {
    // TODO
    // 1. 双击时进入群组的编辑模式
    // 2. 群组编辑模式下，可以对群组内的元素进行拖动等基本操作
  }, [groupId]);

  return (
    <Group id={groupId} onDblClick={handleDblClick}>
      {elements.map((element) => {
        const Element = extensionElements[element.type] || coreElements[element.type];

        if (!Element) return null;

        const elementConfig = getConfigs()[element.type];

        return (
          <ElementWrapper
            key={element.id}
            element={element}
            draggable={draggable}
            selectionMap={staticSeletionMap}
            onDragEnd={onDragEnd}
            config={elementConfig}
            groupId={groupId}
          >
            <Element
              element={element}
              viewport={viewport}
              config={elementConfig}
              currentElementTool={currentElementTool}
              currentCanvasTool={currentCanvasTool}
              editingElementId={editingElementId}
              groupId={groupId}
              groupScale={groupScale}
            />
          </ElementWrapper>
        );
      })}
    </Group>
  );
};

// TODO
// Group元素暂时还没支持通过扩展进行高阶wrap，后面谁有空可以做一下，参考Image组件

export const GroupElement = React.memo((props) => {
  const { element, viewport, draggable, currentElementTool, currentCanvasTool, editingElementId } = props;
  const [groupScale, setGroupScale] = useState({ scaleX: 1, scaleY: 1 });

  const isEditing = editingElementId === element.id;

  useEffect(() => {
    setGroupScale({
      scaleX: element.scaleX,
      scaleY: element.scaleY,
    });
  }, [element.scaleX, element.scaleY]);

  const handleChildDragEnd = useCallback(() => {}, []);

  return (
    <Group
      name={element.id}
      role="element"
      roleType="group"
      id={element.id + '-group'}
      elementId={element.id}
      data={element.data}
      width={element.width}
      height={element.height}
      onDblClick={handleDblClick}
    >
      <GroupElements
        viewport={viewport}
        elements={element.elements}
        draggable={draggable && isEditing}
        groupScale={groupScale}
        groupId={element.id}
        onDragEnd={handleChildDragEnd}
        currentElementTool={currentElementTool}
        currentCanvasTool={currentCanvasTool}
        editingElementId={editingElementId}
      />
    </Group>
  );
});
